/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { HousePlanRestService, HousePlanStyle } from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { HousePlanCheckUsage, HousePlanDetails, HousePlanFilter, HousePlanListItem } from './house-plans.model';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

export interface HousePlanDetailsDialogConfig {
  housePlanId?: ID;
}

@Injectable()
export class HousePlanListBusinessService implements InitViewService,
                                                     InitDialogViewService<HousePlanDetailsDialogConfig> {

  constructor(private housePlanRest: HousePlanRestService,
              private gridLayoutService: GridLayoutService,
              private filterService: FilterRestService,
              private dictionaryService: DictionaryService) {
  }

  initView(): any {
    return {
      housePlanStyles: this.dictionaryService.getByEnum(HousePlanStyle),
      gridLayout: this.gridLayoutService.get('housePlans'),
      housePlanListInit: this.housePlanRest.getListInit(),
      filter: this.filterService.get(FilterNames.housePlans),
    };
  }

  initDialogView(route: DialogRouteSnapshot<HousePlanDetailsDialogConfig>): any {
    return {
      housePlan: route.input.housePlanId ? this.housePlanRest.get(route.input.housePlanId) : {},
      housePlanStyles: this.dictionaryService.getByEnum(HousePlanStyle),
    };
  }

  findAllAsDataSource(filter: HousePlanFilter): SlicedDataSource<HousePlanListItem> {
    return this.housePlanRest.findAllAsDataSource(filter);
  }

  save(housePlan: HousePlanDetails): Observable<HousePlanDetails> {
    return housePlan.housePlanId ? this.housePlanRest.update(housePlan) : this.housePlanRest.create(housePlan);
  }

  activate(id: ID): Observable<HousePlanListItem> {
    return this.housePlanRest.activate(id);
  }

  checkUsage(housePlan: HousePlanListItem): Observable<HousePlanCheckUsage> {
    return this.housePlanRest.checkUsage(housePlan);
  }

  deactivateOrDelete(id: ID, checkUsage: HousePlanCheckUsage): Observable<any> {
    return this.housePlanRest.deactivateOrDelete(id, checkUsage);
  }
}
